// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"d2229c28","86":"5906d70f","134":"93f05224","458":"82abf9d7","494":"6bc2350f","521":"a9f06162","713":"44a9ade3","933":"87b8d7d7","958":"95eac1bb","970":"84065438"}[chunkId] + ".chunk.js";
};